import { IconProps } from '.'

const GenderChooseBoy: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
      {...props}
    >
      <g clipPath="url(#clip0_3_24176)">
        <path
          fill="#45A4FF"
          d="M11.203 7.633l1.914 1.914 6.397-6.397L17.6 1.235l-6.397 6.398z"
        />
        <path
          fill="#45A4FF"
          d="M8.083 5.334a7.333 7.333 0 100 14.667 7.333 7.333 0 000-14.667zm0 11.96a4.626 4.626 0 110-9.253 4.626 4.626 0 010 9.252z"
        />
        <path
          fill="#2D87F3"
          d="M7.508 8.077a4.626 4.626 0 100 9.181 4.627 4.627 0 010-9.181zM8.083 5.334a7.43 7.43 0 00-.575.022 7.334 7.334 0 010 14.622 7.333 7.333 0 10.575-14.644zM19.88 2.785v-.78L18.744.872h-.78l-2.707 2.707h1.55c.2 0 .364.163.364.365v1.55l2.707-2.708z"
        />
        <path
          fill="#45A4FF"
          d="M18.043 0h-4.585a.365.365 0 00-.364.365v1.978c0 .201.163.364.364.364h4.22c.201 0 .365.163.365.365v4.22c0 .2.163.364.364.364h1.978a.365.365 0 00.365-.364V.365A.365.365 0 0020.385 0h-2.342z"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_24176">
          <path fill="#fff" d="M0 0H20V20H0z" transform="translate(.75)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GenderChooseBoy
